/* eslint-disable */
// These values are overridden through clientBuild.
// The values are taken from 00_40_ template
export const dynamicValues = {
  buildVersion: '11955d200d1bf01e07de6de1c43d09cc57cf79ce',
};
/* eslint-enable */
